import React from 'react';

import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ImageThumbnail from '../../../shared/ImageThumbnail/ImageThumbnail';

const TagDiscounts = ({
  loading = false,
  tags,
  discountsTitle,
  primaryColor,
  uiVariantBannerPromo,
}) => {
  return (
    <div className="container">
      <div className="tag-discounts">
        <ItemSlider
          loading={loading}
          title={discountsTitle}
          primaryColor={primaryColor}
          uiVariant={uiVariantBannerPromo}
        >
          {tags &&
            tags.map(tag => {
              return (
                <ImageThumbnail
                  key={tag.id}
                  image={tag.imageUrl}
                  url={`/tag/${tag.seoName}`}
                  uiVariant={uiVariantBannerPromo}
                />
              );
            })}
        </ItemSlider>
      </div>
    </div>
  );
};

export default TagDiscounts;
